import React from 'react';

// Consent banner removed as requested; keep a no-op component to avoid breaking imports
const ConsentBanner: React.FC = () => {
  return null;
};

export default ConsentBanner;
